// extracted by mini-css-extract-plugin
module.exports = {"filter":"pBHjA","label":"_2XYie","actions":"_9NYZw","delete":"QUgS2"};